/**
 * Literales de UI de las cáscaras de vista (views/*.js) y del componente
 * TimelineBar (components/timeline-bar.js).
 *
 * Claves reutilizadas de otros diccionarios (NO re-declaradas aquí):
 *   'Sorteos'          → diccionario-operacion.js   { pt: 'Sorteios' }
 *   'Todos'            → diccionario-operacion.js   { pt: 'Todos' }
 *   'Hoy'              → diccionario-nodos.js        { pt: 'Hoje' }
 *   'Rango'            → diccionario-nodos.js        { pt: 'Faixa' }
 *   'Desde'            → diccionario-nodos.js        { pt: 'De' }
 *   'Hasta'            → diccionario-nodos.js        { pt: 'Até' }
 *   'Jugado'           → diccionario-operacion.js   { pt: 'Apostado' }
 *   'Cobrado'          → diccionario-operacion.js   { pt: 'Recebido' }
 *   'Jugadores'        → diccionario-operacion.js   { pt: 'Jogadores' }
 *   'Actividad'        → diccionario-comunes.js     { pt: 'Atividade' }
 *   'Finanzas'         → diccionario-comunes.js     { pt: 'Finanças' }
 *   'Juegos'           → diccionario-comunes.js     { pt: 'Jogos' }
 *   'Marketing'        → diccionario-comunes.js     { pt: 'Marketing' }
 *   'Clientes'         → diccionario-comunes.js     { pt: 'Clientes' }
 *   'Plataforma'       → diccionario-comunes.js     { pt: 'Plataforma' }
 *   Auditoría          → diccionario-comunes.js     { pt: 'Auditoria' }
 *   'Sistema'          → diccionario-operacion.js   { pt: 'Sistema' }
 *   'Dispositivos'     → diccionario-plataforma.js  { pt: 'Dispositivos' }
 *   'Usuarios'         → diccionario-administracion.js { pt: 'Usuários' }
 *   'Movimientos'      → diccionario-operacion.js   { pt: 'Movimentos' }
 *   'Expandir'         → diccionario-nodos.js        { pt: 'Expandir' }
 *   'Nueva Promocion'  → diccionario-marketing.js   { pt: 'Nova Promoção' }
 *   'Nueva Plantilla'  → diccionario-marketing.js   { pt: 'Novo Modelo' }
 *   'Seleccione un nodo' → diccionario-operacion.js { pt: 'Selecione um nó' }
 *   'Nuevo Bloqueo'    → diccionario-nodos.js        { pt: 'Novo Bloqueio' }
 *   'Estado'           → diccionario-operacion.js   { pt: 'Status' }
 *   'Online'           → diccionario-plataforma.js  { pt: 'Online' }
 *   'Offline'          → diccionario-plataforma.js  { pt: 'Offline' }
 *   'Modalidad'        → diccionario-modales.js     { pt: 'Modalidade' }
 *   'Operadores'       → diccionario-administracion.js { pt: 'Operadores' }
 *   'Propietario'      → diccionario-lotowheel-extra.js { pt: 'Proprietário' }
 *   'Cargando...'      → diccionario-nodos.js        { pt: 'Carregando...' }
 *
 * Solo columna pt (pt-BR canónico del proyecto).
 */

export const DICCIONARIO_VISTAS = {
    // ── Dashboard (command-center) ────────────────────────────────────────────
    'Alertas Operativas': { pt: 'Alertas Operacionais', en: 'Operational Alerts', ru: 'Операционные оповещения' },
    'Configurar alertas': { pt: 'Configurar alertas', en: 'Configure alerts', ru: 'Настроить оповещения' },
    Ingresado: { pt: 'Arrecadado', en: 'Collected', ru: 'Поступило' },
    Rechazados: { pt: 'Rejeitados', en: 'Rejected', ru: 'Отклонены' },
    Compensados: { pt: 'Compensados', en: 'Refunded', ru: 'Возмещены' },
    'En proceso': { pt: 'Em andamento', en: 'In progress', ru: 'В процессе' },
    GGR: { pt: 'GGR', en: 'GGR', ru: 'GGR' },
    RTP: { pt: 'RTP', en: 'RTP', ru: 'RTP' },
    Premiado: { pt: 'Premiado', en: 'Paid out', ru: 'Выплачено' },
    Jogado: { pt: 'Jogado', en: 'Wagered', ru: 'Сыграно' },
    Depósito: { pt: 'Depósito', en: 'Deposit', ru: 'Депозит' },
    Movimientos: { pt: 'Movimentos', en: 'Movements', ru: 'Движения' },
    // 'Rejuego' vive en diccionario-comunes.js (SSOT) — este archivo tenía en:'Replay rate' (ratio),
    // pero los 4 call-sites reales usan el label como MONTO, no porcentaje. Dominio 5 SPEC nomenclatura.
    'Jugadores Activos': { pt: 'Jogadores Ativos', en: 'Active Players', ru: 'Активные игроки' },
    'Total apostado en el período': { pt: 'Total apostado no período', en: 'Total wagered in the period', ru: 'Всего сыграно за период' },
    'Total depositado en el período': { pt: 'Total depositado no período', en: 'Total deposited in the period', ru: 'Всего внесено за период' },
    'Costo de marketing en el período': { pt: 'Custo de marketing no período', en: 'Marketing cost in the period', ru: 'Затраты на маркетинг за период' },
    'Total de movimientos en el período': { pt: 'Total de movimentos no período', en: 'Total movements in the period', ru: 'Всего движений за период' },
    'Total pagado en premios en el período': { pt: 'Total pago em prêmios no período', en: 'Total paid in prizes in the period', ru: 'Всего выплачено призов за период' },
    '% de lo jugado que ya circulaba (no es dinero fresco)': { pt: '% do jogado que já circulava (não é dinheiro novo)', en: '% of wagered that was already circulating (not fresh money)', ru: '% сыгранного, которое уже было в обороте' },
    'Clientes distintos con movimientos en el período': { pt: 'Clientes distintos com movimentos no período', en: 'Distinct customers with movements in the period', ru: 'Уникальные клиенты с движениями за период' },
    'Dispositivos online': { pt: 'Dispositivos online', en: 'Devices online', ru: 'Устройства онлайн' },
    Aparatos: { pt: 'Aparelhos', en: 'Devices', ru: 'Устройства' },
    Promos: { pt: 'Promos', en: 'Promos', ru: 'Акции' },
    'TV (pantallas) + POS (cajas) conectados': {
        pt: 'TV (telas) + POS (caixas) conectados',
        en: 'TV (screens) + POS (registers) connected',
        ru: 'ТВ (экраны) + POS (кассы) подключены',
    },
    'Proximo sorteo:': { pt: 'Próximo sorteio:', en: 'Next draw:', ru: 'Следующий розыгрыш:' },
    'Sorteos hoy:': { pt: 'Sorteios hoje:', en: 'Draws today:', ru: 'Розыгрышей сегодня:' },
    'Sorteos (período):': { pt: 'Sorteios (período):', en: 'Draws (period):', ru: 'Розыгрыши (период):' },
    'Con apuestas': { pt: 'Com apostas', en: 'With bets', ru: 'Со ставками' },
    'Casa +': { pt: 'Casa +', en: 'House +', ru: 'Казино +' },
    'Casa -': { pt: 'Casa -', en: 'House -', ru: 'Казино -' },
    'Últimos 20': { pt: 'Últimos 20', en: 'Last 20', ru: 'Последние 20' },
    'Últimos 50': { pt: 'Últimos 50', en: 'Last 50', ru: 'Последние 50' },
    'Últimos 100': { pt: 'Últimos 100', en: 'Last 100', ru: 'Последние 100' },
    'Últimos 200': { pt: 'Últimos 200', en: 'Last 200', ru: 'Последние 200' },

    // ── Dashboard — vista operativa scoped (no-superadmin) ───────────────────
    // Reusa de otros diccionarios (NO re-declarar): 'Liquidaciones' (operacion),
    // 'Saldo operativo' y 'Límite de crédito' (nodos), 'Ganadores: '
    // (estadisticas), 'Operador'/'Representante' (operacion).
    'Acción necesaria': { pt: 'Ação necessária', en: 'Action required', ru: 'Требуется действие' },
    'Actividad de mi red (tickets)': {
        pt: 'Atividade da sua rede (tickets)',
        en: 'My network activity (tickets)',
        ru: 'Активность моей сети (тикеты)',
    },
    'Cajas offline': { pt: 'Caixas offline', en: 'Tills offline', ru: 'Кассы офлайн' },
    'cajas online': { pt: 'caixas online', en: 'tills online', ru: 'касс онлайн' },
    'Conformidades pendientes': {
        pt: 'Conformidades pendentes',
        en: 'Pending compliance',
        ru: 'Ожидающие соответствия',
    },
    'GGR 7 días': { pt: 'GGR 7 dias', en: 'GGR 7 days', ru: 'GGR за 7 дней' },
    'Mi red': { pt: 'Minha rede', en: 'My network', ru: 'Моя сеть' },
    'Sin actividad': { pt: 'Sem atividade', en: 'No activity', ru: 'Нет активности' },
    'Tendencia 7 días': { pt: 'Tendência 7 dias', en: '7-day trend', ru: 'Тренд за 7 дней' },
    'Tickets ganadores por pagar': {
        pt: 'Tickets premiados a pagar',
        en: 'Winning tickets to pay',
        ru: 'Выигрышные тикеты к оплате',
    },
    'Todo en orden': { pt: 'Tudo em dia', en: 'All in order', ru: 'Всё в порядке' },

    // ── TimelineBar ───────────────────────────────────────────────────────────
    Todo: { pt: 'Tudo', en: 'All', ru: 'Всё' },

    // ── Actividad (tabs y KPIs) ───────────────────────────────────────────────
    Pasarelas: { pt: 'Gateways', en: 'Gateways', ru: 'Шлюзы' },
    Transacciones: { pt: 'Transações', en: 'Transactions', ru: 'Транзакции' },
    Wallets: { pt: 'Carteiras', en: 'Wallets', ru: 'Кошельки' },
    Integradores: { pt: 'Integradores', en: 'Integrators', ru: 'Интеграторы' },
    'Vendidos Hoy': { pt: 'Vendidos Hoje', en: 'Sold Today', ru: 'Продано сегодня' },
    'Por Cobrar': { pt: 'A Receber', en: 'To Collect', ru: 'К получению' },
    'Vencen en 7 días': { pt: 'Vencem em 7 dias', en: 'Expire within 7 days', ru: 'Истекают за 7 дней' },
    Recientes: { pt: 'Recentes', en: 'Recent', ru: 'Недавние' },
    'Buscar por nombre o ID...': { pt: 'Buscar por nome ou ID...', en: 'Search by name or ID...', ru: 'Поиск по имени или ID...' },
    'Ningún nodo en este nivel de saldo': { pt: 'Nenhum nó neste nível de saldo', en: 'No nodes at this balance level', ru: 'Нет узлов с таким уровнем баланса' },
    'Sin saldo — el nodo no puede vender hasta recargar': { pt: 'Sem saldo — o nó não pode vender até recarregar', en: 'No balance — the node cannot sell until recharged', ru: 'Нет баланса — узел не может продавать до пополнения' },
    'Saldo casi agotado — recargar pronto': { pt: 'Saldo quase esgotado — recarregar em breve', en: 'Balance almost depleted — recharge soon', ru: 'Баланс почти исчерпан — скоро потребуется пополнение' },
    'Saldo bajo el umbral de aviso': { pt: 'Saldo abaixo do limite de aviso', en: 'Balance below the warning threshold', ru: 'Баланс ниже порога предупреждения' },
    'Última recarga': { pt: 'Última recarga', en: 'Last recharge', ru: 'Последнее пополнение' },
    por: { pt: 'por', en: 'by', ru: 'от' },
    'Nunca recargado': { pt: 'Nunca recarregado', en: 'Never recharged', ru: 'Никогда не пополнялся' },
    'Desde el corte': { pt: 'Desde o fechamento', en: 'Since closing', ru: 'С момента закрытия' },
    recibido: { pt: 'recebido', en: 'received', ru: 'получено' },
    pagado: { pt: 'pago', en: 'paid', ru: 'оплачено' },
    'Ver Bilhetes': { pt: 'Ver Bilhetes', en: 'View Tickets', ru: 'Посмотреть билеты' },
    'Ver tickets y premios pendientes de este nodo': { pt: 'Ver bilhetes e prêmios pendentes deste nó', en: 'View tickets and pending prizes for this node', ru: 'Посмотреть билеты и невыплаченные призы этого узла' },
    'Desde el último corte de este nodo': { pt: 'Desde o último fechamento deste nó', en: 'Since this node\'s last closing', ru: 'С последнего закрытия этого узла' },
    'Premios por Pagar': { pt: 'Prêmios a Pagar', en: 'Prizes to Pay', ru: 'Призы к выплате' },
    Circulante: { pt: 'Circulante', en: 'Outstanding', ru: 'В обороте' },
    'Total en wallets': { pt: 'Total em wallets', en: 'Total in wallets', ru: 'Всего в кошельках' },
    'Dinero cargado y aún no jugado ni retirado': { pt: 'Dinheiro carregado e ainda não jogado nem sacado', en: 'Money loaded and not yet played or withdrawn', ru: 'Деньги на счетах, ещё не сыгранные и не выведенные' },
    'Saldo real': { pt: 'Saldo real', en: 'Real balance', ru: 'Реальный баланс' },
    'Depósitos y premios acreditados': { pt: 'Depósitos e prêmios creditados', en: 'Deposits and credited prizes', ru: 'Депозиты и зачисленные призы' },
    'Bônus vigente': { pt: 'Bônus vigente', en: 'Active bonus', ru: 'Действующий бонус' },
    'Bonus otorgado sin expirar (no retirable)': { pt: 'Bônus concedido sem expirar (não sacável)', en: 'Granted bonus not expired (non-withdrawable)', ru: 'Начисленный бонус без истечения (не выводится)' },
    'Jugadores con saldo': { pt: 'Jogadores com saldo', en: 'Players with balance', ru: 'Игроки с балансом' },
    'Clientes con dinero en la wallet ahora': { pt: 'Clientes com dinheiro na wallet agora', en: 'Customers with wallet money right now', ru: 'Клиенты с деньгами в кошельке сейчас' },
    'No hay premios pendientes de pago': { pt: 'Não há prêmios pendentes de pagamento', en: 'No prizes pending payment', ru: 'Нет призов, ожидающих выплаты' },
    'Confirmar pago de': { pt: 'Confirmar pagamento de', en: 'Confirm payment of', ru: 'Подтвердить выплату' },
    'Pagando...': { pt: 'Pagando...', en: 'Paying...', ru: 'Выплата...' },
    'Premio pagado desde tu nodo': { pt: 'Prêmio pago do seu nó', en: 'Prize paid from your node', ru: 'Приз выплачен с вашего узла' },
    'Error al pagar': { pt: 'Erro ao pagar', en: 'Payment error', ru: 'Ошибка выплаты' },
    tickets: { pt: 'bilhetes', en: 'tickets', ru: 'билетов' },
    'Apostado Hoy': { pt: 'Apostado Hoje', en: 'Bet Today', ru: 'Поставлено сегодня' },
    'Pagado Hoy': { pt: 'Pago Hoje', en: 'Paid Today', ru: 'Выплачено сегодня' },
    'Depósitos Hoy': { pt: 'Depósitos Hoje', en: 'Top-ups Today', ru: 'Пополнения сегодня' },
    'Retiros Hoy': { pt: 'Saques Hoje', en: 'Withdrawals Today', ru: 'Выводы сегодня' },
    'Saldo en Cajas': { pt: 'Saldo em Caixas', en: 'Balance in Tills', ru: 'Баланс в кассах' },
    'Saldo Clientes': { pt: 'Saldo Clientes', en: 'Customer Balance', ru: 'Баланс клиентов' },
    'Transacciones Hoy': { pt: 'Transações Hoje', en: 'Transactions Today', ru: 'Транзакции сегодня' },
    'Tasa de Exito': { pt: 'Taxa de Sucesso', en: 'Success Rate', ru: 'Доля успешных' },
    'GGR Hoy': { pt: 'GGR Hoje', en: 'GGR Today', ru: 'GGR сегодня' },
    'Latencia Prom.': { pt: 'Latência Méd.', en: 'Avg. Latency', ru: 'Сред. задержка' },
    'Éxito Transacción': { pt: 'Sucesso na Transação', en: 'Transaction Success', ru: 'Успех транзакции' },
    'Pendiente Gateway': { pt: 'Pendente no Gateway', en: 'Pending at Gateway', ru: 'Ожидает в шлюзе' },
    'Costo de plataforma': { pt: 'Custo de plataforma', en: 'Platform cost', ru: 'Расходы платформы' },
    Desistieron: { pt: 'Desistiram', en: 'Abandoned', ru: 'Отказались' },
    // Sublabels agnósticos de los KPIs de la pasarela: explican QUÉ mide cada
    // número en términos contables (sin atar a un proveedor/país/método).
    '% de transacciones completadas (excluye desistidas)': {
        pt: '% de transações concluídas (exclui desistidas)',
        en: '% of completed transactions (excludes abandoned)',
        ru: '% завершённых транзакций (без отказов)',
    },
    'Dinero en tránsito, aún sin confirmar': {
        pt: 'Dinheiro em trânsito, ainda sem confirmar',
        en: 'Money in transit, not yet confirmed',
        ru: 'Деньги в пути, ещё не подтверждены',
    },
    'Costo del proveedor en el período': {
        pt: 'Custo do provedor no período',
        en: "Provider's cost in the period",
        ru: 'Расходы провайдера за период',
    },
    'Entradas − Salidas − Costo de plataforma': {
        pt: 'Entradas − Saídas − Custo de plataforma',
        en: 'Inflows − Outflows − Platform cost',
        ru: 'Поступления − Выплаты − Расходы платформы',
    },
    // ── Panel Proveedores de pasarela (Finanzas → Proveedores) ──
    Proveedores: { pt: 'Provedores', en: 'Providers', ru: 'Провайдеры' },
    'Proveedores de pasarela': { pt: 'Provedores de pagamento', en: 'Payment providers', ru: 'Платёжные провайдеры' },
    'Credenciales y tarifa de cada plataforma de pago. Solo super administrador.': {
        pt: 'Credenciais e tarifa de cada plataforma de pagamento. Apenas super administrador.',
        en: 'Credentials and fee for each payment platform. Super admin only.',
        ru: 'Учётные данные и тариф каждой платёжной платформы. Только суперадминистратор.',
    },
    'Nuevo proveedor': { pt: 'Novo provedor', en: 'New provider', ru: 'Новый провайдер' },
    'Editar proveedor': { pt: 'Editar provedor', en: 'Edit provider', ru: 'Изменить провайдера' },
    'No hay proveedores configurados': { pt: 'Não há provedores configurados', en: 'No providers configured', ru: 'Нет настроенных провайдеров' },
    'No se pudieron cargar los proveedores': { pt: 'Não foi possível carregar os provedores', en: 'Could not load providers', ru: 'Не удалось загрузить провайдеров' },
    'No se pudo cargar el proveedor': { pt: 'Não foi possível carregar o provedor', en: 'Could not load provider', ru: 'Не удалось загрузить провайдера' },
    Probar: { pt: 'Testar', en: 'Test', ru: 'Проверить' },
    'Probando conexión…': { pt: 'Testando conexão…', en: 'Testing connection…', ru: 'Проверка соединения…' },
    'Conexión correcta': { pt: 'Conexão correta', en: 'Connection OK', ru: 'Соединение в порядке' },
    'Falló la prueba': { pt: 'A prova falhou', en: 'Test failed', ru: 'Проверка не удалась' },
    'El proveedor no se puede cambiar tras crear.': {
        pt: 'O provedor não pode ser alterado após criar.',
        en: 'The provider cannot be changed after creation.',
        ru: 'Провайдера нельзя изменить после создания.',
    },
    'Dejar vacío para no cambiar': { pt: 'Deixe vazio para não alterar', en: 'Leave empty to keep unchanged', ru: 'Оставьте пустым, чтобы не менять' },
    'ej: PIX PodBank principal': { pt: 'ex: PIX PodBank principal', en: 'e.g. PIX PodBank main', ru: 'напр.: PIX PodBank основной' },
    'El nombre es obligatorio': { pt: 'O nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    'Proveedor creado': { pt: 'Provedor criado', en: 'Provider created', ru: 'Провайдер создан' },
    'Proveedor actualizado': { pt: 'Provedor atualizado', en: 'Provider updated', ru: 'Провайдер обновлён' },
    'Proveedor eliminado': { pt: 'Provedor excluído', en: 'Provider deleted', ru: 'Провайдер удалён' },
    '¿Eliminar el proveedor': { pt: 'Excluir o provedor', en: 'Delete provider', ru: 'Удалить провайдера' },
    'No se pudo eliminar': { pt: 'Não foi possível excluir', en: 'Could not delete', ru: 'Не удалось удалить' },
    'Error al guardar': { pt: 'Erro ao salvar', en: 'Error saving', ru: 'Ошибка сохранения' },
    'Solo el super administrador puede modificar proveedores.': {
        pt: 'Apenas o super administrador pode modificar provedores.',
        en: 'Only the super administrator can modify providers.',
        ru: 'Только суперадминистратор может изменять провайдеров.',
    },
    // ── Tarifa al jugador (modal Proveedores) ──
    'Tarifa al jugador (opcional)': { pt: 'Tarifa ao jogador (opcional)', en: 'Player fee (optional)', ru: 'Комиссия игрока (необязательно)' },
    'Lo que se le cobra al jugador SOLO si la rama elige que él pague la tasa. Vacío = la casa la absorbe.': {
        pt: 'O que é cobrado do jogador SOMENTE se o ramo escolher que ele pague a taxa. Vazio = a casa absorve.',
        en: 'Charged to the player ONLY if the branch chooses that he pays the fee. Empty = the house absorbs it.',
        ru: 'Взимается с игрока ТОЛЬКО если ветка выбрала, что платит он. Пусто = расходы берёт компания.',
    },
    'El banco tiene bloqueado el CPF o la clave PIX del pagador y no acepta enviarle dinero. Ninguna devolución por PIX va a salir hasta que el banco lo desbloquee.': {
        pt: 'O banco bloqueou o CPF ou a chave PIX do pagador e não aceita enviar dinheiro a ele. Nenhuma devolução por PIX vai sair até o banco desbloquear.',
        en: 'The bank has blocked the payer CPF or PIX key and refuses to send them money. No PIX refund will go through until the bank unblocks it.',
        ru: 'Банк заблокировал CPF или PIX-ключ плательщика и не принимает переводы ему. Возврат по PIX не пройдёт, пока банк не снимет блокировку.',
    },
    'El banco anuló la clave del intento anterior fallido. Al volver a tocar el botón, el sistema sale con una clave nueva.': {
        pt: 'O banco anulou a chave da tentativa anterior que falhou. Ao tocar o botão de novo, o sistema sai com uma chave nova.',
        en: 'The bank voided the key of the previous failed attempt. Pressing the button again sends with a fresh key.',
        ru: 'Банк аннулировал ключ прошлой неудачной попытки. При повторном нажатии система отправит с новым ключом.',
    },
    'El banco del pagador no permite reversar el PIX original por sistema. Se puede devolver con "Devolver por PIX" (envía un PIX nuevo a su CPF).': {
        pt: 'O banco do pagador não permite reverter o PIX original pelo sistema. Dá para devolver com "Devolver por PIX" (envia um PIX novo ao CPF dele).',
        en: 'The payer bank does not allow reversing the original PIX programmatically. Use "Refund via PIX" (sends a new PIX to their CPF).',
        ru: 'Банк плательщика не позволяет программно отменить исходный PIX. Используйте «Вернуть по PIX» (отправляет новый PIX на его CPF).',
    },
    'El servicio del banco procesador está desactivado en este momento. Reintentar más tarde o consultar al proveedor de pagos.': {
        pt: 'O serviço do banco processador está desativado neste momento. Tentar de novo mais tarde ou consultar o provedor de pagamentos.',
        en: 'The processing bank service is currently disabled. Retry later or contact the payment provider.',
        ru: 'Сервис банка-процессора сейчас отключён. Повторите позже или обратитесь к платёжному провайдеру.',
    },
    'El banco no respondió a tiempo y el PIX pudo haber salido igual. No reintentar: verificar primero en el banco si el dinero salió.': {
        pt: 'O banco não respondeu a tempo e o PIX pode ter saído mesmo assim. Não tentar de novo: verificar primeiro no banco se o dinheiro saiu.',
        en: 'The bank did not respond in time and the PIX may have gone out anyway. Do not retry: first check at the bank whether the money left.',
        ru: 'Банк не ответил вовремя, и PIX мог всё же уйти. Не повторяйте: сначала проверьте в банке, ушли ли деньги.',
    },
    'Mensaje del banco:': {
        pt: 'Mensagem do banco:',
        en: 'Bank message:',
        ru: 'Сообщение банка:',
    },
    'Devolución automática por PIX si el estorno falla': {
        pt: 'Devolução automática por PIX se o estorno falhar',
        en: 'Automatic PIX refund if the reversal fails',
        ru: 'Автоматический возврат по PIX при сбое отмены',
    },
    'Recargas retenidas por titularidad: si la reversa del PIX original falla en el banco, el sistema envía solo un PIX al CPF del pagador. Si también falla, queda el botón manual.': {
        pt: 'Depósitos retidos por titularidade: se a reversão do PIX original falhar no banco, o sistema envia sozinho um PIX ao CPF do pagador. Se também falhar, fica o botão manual.',
        en: 'Deposits retained by ownership: if the reversal of the original PIX fails at the bank, the system sends a PIX to the payer CPF on its own. If that also fails, the manual button remains.',
        ru: 'Депозиты, удержанные из-за владельца: если отмена исходного PIX не проходит в банке, система сама отправляет PIX на CPF плательщика. Если и это не удастся — остаётся ручная кнопка.',
    },
    'En recarga': { pt: 'No depósito', en: 'On top-up', ru: 'При пополнении' },
    'En retiro': { pt: 'No saque', en: 'On withdrawal', ru: 'При выводе' },
    'Sin cargo': { pt: 'Sem cobrança', en: 'No charge', ru: 'Без сбора' },
    Porcentaje: { pt: 'Porcentagem', en: 'Percentage', ru: 'Процент' },
    'Monto fijo': { pt: 'Valor fixo', en: 'Fixed amount', ru: 'Фиксированная сумма' },
    'Porcentaje + fijo': { pt: 'Porcentagem + fixo', en: 'Percentage + fixed', ru: 'Процент + фикс.' },
    'Porcentaje con mínimo': { pt: 'Porcentagem com mínimo', en: 'Percentage with minimum', ru: 'Процент с минимумом' },
    'Porcentaje con tope': { pt: 'Porcentagem com teto', en: 'Percentage with cap', ru: 'Процент с потолком' },
    'Porcentaje (%)': { pt: 'Porcentagem (%)', en: 'Percentage (%)', ru: 'Процент (%)' },
    Fijo: { pt: 'Fixo', en: 'Fixed', ru: 'Фикс.' },
    'Esta tarifa usa tramos escalonados — editar por configuración avanzada.': {
        pt: 'Esta tarifa usa faixas escalonadas — editar por configuração avançada.',
        en: 'This fee uses tiered ranges — edit via advanced configuration.',
        ru: 'Этот тариф использует ступенчатые диапазоны — изменить через расширенную настройку.',
    },
    'Transacciones inconsistentes detectadas': {
        pt: 'Transações inconsistentes detectadas',
        en: 'Inconsistent transactions detected',
        ru: 'Обнаруженные несоответствия',
    },
    'Generaron el cobro pero nunca pagaron': {
        pt: 'Geraram a cobrança mas nunca pagaram',
        en: 'Generated the charge but never paid',
        ru: 'Создали счёт, но не оплатили',
    },
    'Generaron el cobro pero nunca pagaron (no es un fallo de la pasarela)': {
        pt: 'Geraram a cobrança mas nunca pagaram (não é falha do gateway)',
        en: 'Generated the charge but never paid (not a gateway failure)',
        ru: 'Создали счёт, но не оплатили (не сбой шлюза)',
    },
    'Tiempo de respuesta del provider': {
        pt: 'Tempo de resposta do provedor',
        en: 'Provider response time',
        ru: 'Время ответа провайдера',
    },
    'Sin confirmaciones en el rango': {
        pt: 'Sem confirmações no período',
        en: 'No confirmations in range',
        ru: 'Нет подтверждений за период',
    },
    Provider: { pt: 'Provedor', en: 'Provider', ru: 'Провайдер' },
    Total: { pt: 'Total', en: 'Total', ru: 'Всего' },
    confirmadas: { pt: 'confirmadas', en: 'confirmed', ru: 'подтверждено' },
    'Lag del provider: desde que manda el webhook hasta que su API confirma': {
        pt: 'Lag do provedor: do envio do webhook até a API confirmar',
        en: 'Provider lag: from webhook sent until its API confirms',
        ru: 'Задержка провайдера: от отправки вебхука до подтверждения API',
    },
    'Total que esperó el jugador (incluye su tiempo de pago)': {
        pt: 'Total que o jogador esperou (inclui o tempo de pagamento)',
        en: 'Total the player waited (includes their payment time)',
        ru: 'Общее ожидание игрока (включая время оплаты)',
    },
    jugador: { pt: 'jogador', en: 'player', ru: 'игрок' },
    banco: { pt: 'banco', en: 'bank', ru: 'банк' },
    Confirmación: { pt: 'Confirmação', en: 'Confirmation', ru: 'Подтверждение' },
    webhook: { pt: 'webhook', en: 'webhook', ru: 'webhook' },
    reintento: { pt: 'reenvio', en: 'retry', ru: 'повтор' },
    polling: { pt: 'polling', en: 'polling', ru: 'опрос' },
    confirmando: { pt: 'confirmando', en: 'confirming', ru: 'подтверждается' },
    'pendiente jugador': { pt: 'aguardando jogador', en: 'awaiting player', ru: 'ожидание игрока' },
    cancelado: { pt: 'cancelado', en: 'cancelled', ru: 'отменён' },
    desistió: { pt: 'desistiu', en: 'abandoned', ru: 'отказался' },
    'cliente desistió': { pt: 'cliente desistiu', en: 'customer abandoned', ru: 'клиент отказался' },
    'no completado': { pt: 'não concluído', en: 'not completed', ru: 'не завершён' },
    no_completado: { pt: 'não concluído', en: 'not completed', ru: 'не завершён' },
    recarga: { pt: 'recarga', en: 'top-up', ru: 'пополнение' },
    retiro: { pt: 'saque', en: 'withdrawal', ru: 'вывод' },
    Recarga: { pt: 'Recarga', en: 'Top-up', ru: 'Пополнение' },
    Retiro: { pt: 'Saque', en: 'Withdrawal', ru: 'Вывод' },
    'Total recargado en el período': { pt: 'Total recarregado no período', en: 'Total topped up in the period', ru: 'Всего пополнено за период' },
    'Total retirado en el período': { pt: 'Total sacado no período', en: 'Total withdrawn in the period', ru: 'Всего выведено за период' },
    exitoso: { pt: 'bem-sucedido', en: 'successful', ru: 'успешно' },
    fallido: { pt: 'falhou', en: 'failed', ru: 'неудачно' },
    pendiente: { pt: 'pendente', en: 'pending', ru: 'в ожидании' },
    Causa: { pt: 'Causa', en: 'Cause', ru: 'Причина' },
    'pagó sin acreditar': { pt: 'pagou sem creditar', en: 'paid not credited', ru: 'оплачен без зачисления' },
    'cuenta bloqueada': { pt: 'conta bloqueada', en: 'account blocked', ru: 'счёт заблокирован' },
    'peticiones repetidas excesivas': {
        pt: 'pedidos repetidos em excesso',
        en: 'too many repeated requests',
        ru: 'слишком много повторных запросов',
    },
    'saque repetido': { pt: 'saque repetido', en: 'duplicate withdrawal', ru: 'повторный вывод' },
    'CPF/clave en blacklist': {
        pt: 'CPF/chave em blacklist',
        en: 'CPF/key blacklisted',
        ru: 'CPF/ключ в чёрном списке',
    },
    'clave PIX inválida': { pt: 'chave PIX inválida', en: 'invalid PIX key', ru: 'неверный PIX-ключ' },
    'cuenta destino no consultable': {
        pt: 'conta destino indisponível',
        en: 'destination acct unreachable',
        ru: 'счёт получателя недоступен',
    },
    'saldo insuficiente': { pt: 'saldo insuficiente', en: 'insufficient balance', ru: 'недостаточно средств' },
    'timeout del provider': { pt: 'timeout do provedor', en: 'provider timeout', ru: 'таймаут провайдера' },
    fallo: { pt: 'falha', en: 'failed', ru: 'сбой' },
    'Lo que tardó el jugador en pagar tras generar el cobro': {
        pt: 'O que o jogador demorou a pagar após gerar a cobrança',
        en: 'How long the player took to pay after generating the charge',
        ru: 'Сколько игрок платил после создания счёта',
    },
    'Lo que tardó el banco en reflejar el pago tras la liquidación': {
        pt: 'O que o banco demorou a refletir o pagamento após a liquidação',
        en: 'How long the bank took to reflect the payment after settlement',
        ru: 'Сколько банк отражал платёж после расчёта',
    },
    'Buscar por codigo (ABC12345)...': {
        pt: 'Buscar por código (ABC12345)...',
        en: 'Search by code (ABC12345)...',
        ru: 'Поиск по коду (ABC12345)...',
    },

    // ── Auditoría (tabs y sesiones) ───────────────────────────────────────────
    Auditoria: { pt: 'Auditoria', en: 'Audit', ru: 'Аудит' },
    'Sesiones Jugadores': { pt: 'Sessões Jogadores', en: 'Player Sessions', ru: 'Сессии игроков' },
    'Series Tickets': { pt: 'Séries de Tickets', en: 'Ticket Series', ru: 'Серии тикетов' },
    'Fleet Crashes': { pt: 'Fleet Crashes', en: 'Fleet Crashes', ru: 'Сбои парка устройств' },
    'WhatsApp Config': { pt: 'Config WhatsApp', en: 'WhatsApp Config', ru: 'Настройка WhatsApp' },
    'Activas ahora': { pt: 'Ativas agora', en: 'Active now', ru: 'Активны сейчас' },
    'Sesiones hoy': { pt: 'Sessões hoje', en: 'Sessions today', ru: 'Сессий сегодня' },
    'Duracion promedio (min)': {
        pt: 'Duração média (min)',
        en: 'Average duration (min)',
        ru: 'Средняя длительность (мин)',
    },
    'Jugadores unicos hoy': {
        pt: 'Jogadores únicos hoje',
        en: 'Unique players today',
        ru: 'Уникальных игроков сегодня',
    },
    'Sesiones Activas': { pt: 'Sessões Ativas', en: 'Active Sessions', ru: 'Активные сессии' },
    Actualizar: { pt: 'Atualizar', en: 'Refresh', ru: 'Обновить' },
    'Historial de Sesiones': { pt: 'Histórico de Sessões', en: 'Session History', ru: 'История сессий' },
    'Series de Tickets': { pt: 'Séries de Tickets', en: 'Ticket Series', ru: 'Серии тикетов' },
    'Nueva Serie': { pt: 'Nova Série', en: 'New Series', ru: 'Новая серия' },
    'Master Key': { pt: 'Chave Mestra', en: 'Master Key', ru: 'Мастер-ключ' },
    'Rango de tickets': { pt: 'Faixa de tickets', en: 'Ticket range', ru: 'Диапазон тикетов' },
    'Crashes agregados (top regresiones por release)': {
        pt: 'Crashes agregados (top regressões por release)',
        en: 'Aggregated crashes (top regressions by release)',
        ru: 'Агрегированные сбои (топ регрессий по релизу)',
    },
    Exception: { pt: 'Exceção', en: 'Exception', ru: 'Исключение' },
    'APK version': { pt: 'Versão APK', en: 'APK version', ru: 'Версия APK' },
    Primero: { pt: 'Primeiro', en: 'First', ru: 'Первый' },
    Último: { pt: 'Último', en: 'Last', ru: 'Последний' },
    'WhatsApp Accessibility Config': {
        pt: 'Config Acessibilidade WhatsApp',
        en: 'WhatsApp Accessibility Config',
        ru: 'Настройка доступности WhatsApp',
    },
    'Nueva versión': { pt: 'Nova versão', en: 'New version', ru: 'Новая версия' },
    'Resource IDs del botón "Enviar" de WhatsApp / WhatsApp Business para automatización del POS. Cross-operador. WhatsApp publica el mismo APK globalmente — los IDs cambian entre versiones, no por país. Solo la fila marcada vigente es la que sirve':
        {
            pt: 'Resource IDs do botão "Enviar" do WhatsApp / WhatsApp Business para automação do POS. Cross-operador. O WhatsApp publica o mesmo APK globalmente — os IDs mudam entre versões, não por país. Apenas a linha marcada como vigente é a que serve',
            en: 'Resource IDs of the "Send" button of WhatsApp / WhatsApp Business for POS automation. Cross-operator. WhatsApp publishes the same APK globally — the IDs change between versions, not by country. Only the row marked as current is the one that works',
            ru: 'Resource ID кнопки «Отправить» в WhatsApp / WhatsApp Business для автоматизации точки продаж. Кросс-операторский. WhatsApp публикует одинаковый APK по всему миру — ID меняются между версиями, а не по странам. Работает только строка, отмеченная как действующая',
        },
    Versión: { pt: 'Versão', en: 'Version', ru: 'Версия' },
    'Resource IDs': { pt: 'Resource IDs', en: 'Resource IDs', ru: 'Resource IDs' },

    // ── Clientes (tabs y bloqueos) ────────────────────────────────────────────
    Bloqueos: { pt: 'Bloqueios', en: 'Blocks', ru: 'Блокировки' },
    'Bloqueos Activos': { pt: 'Bloqueios Ativos', en: 'Active Blocks', ru: 'Активные блокировки' },

    // ── Finanzas (tabs) ───────────────────────────────────────────────────────
    Saldos: { pt: 'Saldos', en: 'Balances', ru: 'Балансы' },
    'Saldos Nodos': { pt: 'Saldos dos Nós', en: 'Node Balances', ru: 'Балансы узлов' },
    Transferencias: { pt: 'Transferências', en: 'Transfers', ru: 'Переводы' },
    Cierres: { pt: 'Fechamentos', en: 'Closings', ru: 'Закрытия' },
    Alertas: { pt: 'Alertas', en: 'Alerts', ru: 'Оповещения' },
    'Saldos de la Red': { pt: 'Saldos da Rede', en: 'Network Balances', ru: 'Балансы сети' },
    'Nodos con prepago activo — recargar, ver estado, gestionar': {
        pt: 'Nós com pré-pago ativo — recarregar, ver status, gerenciar',
        en: 'Nodes with active prepay — top up, view status, manage',
        ru: 'Узлы с активной предоплатой — пополнить, посмотреть статус, управлять',
    },

    // ── Juegos (tabs y virtuales) ─────────────────────────────────────────────
    'Cargando juegos...': { pt: 'Carregando jogos...', en: 'Loading games...', ru: 'Загрузка игр...' },
    Publicos: { pt: 'Públicos', en: 'Public', ru: 'Публичные' },
    Virtuales: { pt: 'Virtuais', en: 'Virtual', ru: 'Виртуальные' },
    'Nuevo Sorteo LotoWheel': {
        pt: 'Novo Sorteio LotoWheel',
        en: 'New LotoWheel Draw',
        ru: 'Новый розыгрыш LotoWheel',
    },
    'Activos en RAM': { pt: 'Ativos em RAM', en: 'Active in RAM', ru: 'Активны в RAM' },
    Memoria: { pt: 'Memória', en: 'Memory', ru: 'Память' },
    'Total Creados': { pt: 'Total Criados', en: 'Total Created', ru: 'Всего создано' },
    'Recuperar Huérfanos': { pt: 'Recuperar Órfãos', en: 'Recover Orphans', ru: 'Восстановить осиротевшие' },
    'Crear Sorteo Virtual': {
        pt: 'Criar Sorteio Virtual',
        en: 'Create Virtual Draw',
        ru: 'Создать виртуальный розыгрыш',
    },
    'Sorteos Virtuales Activos': {
        pt: 'Sorteios Virtuais Ativos',
        en: 'Active Virtual Draws',
        ru: 'Активные виртуальные розыгрыши',
    },
    'Nuevo Pozo': { pt: 'Nova Poça', en: 'New Pool', ru: 'Новый пул' },

    // ── Marketing (tabs y buscador) ───────────────────────────────────────────
    Promociones: { pt: 'Promoções', en: 'Promotions', ru: 'Акции' },
    'Crear/Modificar Plantillas': {
        pt: 'Criar/Modificar Modelos',
        en: 'Create/Edit Templates',
        ru: 'Создать/изменить шаблоны',
    },
    Cupones: { pt: 'Cupons', en: 'Coupons', ru: 'Купоны' },
    'Buscador e Historial': { pt: 'Buscador e Histórico', en: 'Search and History', ru: 'Поиск и история' },
    'Historial de recompensas': { pt: 'Histórico de recompensas', en: 'Rewards history', ru: 'История наград' },
    'Promociones activas': { pt: 'Promoções ativas', en: 'Active promotions', ru: 'Активные акции' },
    Plantillas: { pt: 'Modelos', en: 'Templates', ru: 'Шаблоны' },
    'Clientes con promos': { pt: 'Clientes com promos', en: 'Customers with promos', ru: 'Клиенты с акциями' },
    Referidos: { pt: 'Indicações', en: 'Referrals', ru: 'Рефералы' },

    // ── Plataforma (tabs, árbol, dispositivos) ────────────────────────────────
    'Red Operativa': { pt: 'Rede Operacional', en: 'Operational Network', ru: 'Операционная сеть' },
    'Estructura de Red': { pt: 'Estrutura da Rede', en: 'Network Structure', ru: 'Структура сети' },
    '+ Nuevo': { pt: '+ Novo', en: '+ New', ru: '+ Новый' },
    'Seleccione un nodo para ver sus detalles': {
        pt: 'Selecione um nó para ver seus detalhes',
        en: 'Select a node to view its details',
        ru: 'Выберите узел, чтобы увидеть детали',
    },
    'Pendientes de Autorizar': {
        pt: 'Pendentes de Autorização',
        en: 'Pending Authorization',
        ru: 'Ожидают авторизации',
    },
    'Dispositivos Registrados': {
        pt: 'Dispositivos Registrados',
        en: 'Registered Devices',
        ru: 'Зарегистрированные устройства',
    },
    'Buscar por nombre, serial...': {
        pt: 'Buscar por nome, serial...',
        en: 'Search by name, serial...',
        ru: 'Поиск по имени, серийному номеру...',
    },
    'Todos los tipos': { pt: 'Todos os tipos', en: 'All types', ru: 'Все типы' },
    Screen: { pt: 'Screen', en: 'Screen', ru: 'Screen' },
    'Tipo de dispositivo': { pt: 'Tipo de dispositivo', en: 'Device type', ru: 'Тип устройства' },
    Status: { pt: 'Status', en: 'Status', ru: 'Статус' },
    Representantes: { pt: 'Representantes', en: 'Representatives', ru: 'Представители' },
    Activas: { pt: 'Ativas', en: 'Active', ru: 'Активные' },
    Inactivas: { pt: 'Inativas', en: 'Inactive', ru: 'Неактивные' },

    // ── Dashboard de RED (vista "quién produce y quién no") ───────────────────
    // 'Jugado' vive en diccionario-comunes.js (SSOT) — este archivo se importa último en index.js y
    // pisaba silenciosamente el merge con un valor PT/RU desactualizado ('Apostado'/'Поставлено').
    'Dinero fresco': { pt: 'Dinheiro novo', en: 'Fresh money', ru: 'Свежие деньги' },
    'Ordenar por': { pt: 'Ordenar por', en: 'Sort by', ru: 'Сортировать по' },
    'Desempeño de la red': {
        pt: 'Desempenho da rede',
        en: 'Network performance',
        ru: 'Показатели сети',
    },
    'Ranking de sub-nodos': { pt: 'Ranking de sub-nós', en: 'Sub-node ranking', ru: 'Рейтинг узлов' },
    'Composición del GGR': { pt: 'Composição do GGR', en: 'GGR breakdown', ru: 'Структура GGR' },
    'Salud de la red — calidad de captación': {
        pt: 'Saúde da rede — qualidade de captação',
        en: 'Network health — acquisition quality',
        ru: 'Здоровье сети — качество привлечения',
    },
    Adquisición: { pt: 'Aquisição', en: 'Acquisition', ru: 'Привлечение' },
    Calidad: { pt: 'Qualidade', en: 'Quality', ru: 'Качество' },
    Conversión: { pt: 'Conversão', en: 'Conversion', ru: 'Конверсия' },
    'Salud de la red': { pt: 'Saúde da rede', en: 'Network health', ru: 'Здоровье сети' },
    'calidad de captación': { pt: 'qualidade de captação', en: 'acquisition quality', ru: 'качество привлечения' },
    General: { pt: 'Geral', en: 'Overall', ru: 'Общий' },
    'Pez gordo': { pt: 'Peixe gordo', en: 'Big fish', ru: 'Крупная рыба' },
    Retención: { pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    // Cabeceras ejecutivas del panel de salud de red (2 líneas: sigla + sub).
    // Claves en portugués (el componente las pasa por t() tal cual) → llevan `es`.
    Índice: { es: 'Índice', pt: 'Índice', en: 'Index', ru: 'Индекс' },
    Global: { es: 'Global', pt: 'Global', en: 'Global', ru: 'Общий' },
    Receita: { es: 'Renta', pt: 'Receita', en: 'Revenue', ru: 'Доход' },
    'Receita/Jogador': { es: 'Renta/Jugador', pt: 'Receita/Jogador', en: 'Revenue/Player', ru: 'Доход/игрок' },
    Retenção: { es: 'Retención', pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    Ativos: { es: 'Activos', pt: 'Ativos', en: 'Active', ru: 'Активные' },
    FTD: { pt: 'FTD', en: 'FTD', ru: 'FTD' },
    Conversão: { es: 'Conversión', pt: 'Conversão', en: 'Conversion', ru: 'Конверсия' },
    Aquisição: { es: 'Adquisición', pt: 'Aquisição', en: 'Acquisition', ru: 'Привлечение' },
    Captados: { es: 'Captados', pt: 'Captados', en: 'Acquired', ru: 'Привлечено' },
    'Sin sub-nodos': { pt: 'Sem sub-nós', en: 'No sub-nodes', ru: 'Нет подузлов' },
    '14 días': { pt: '14 dias', en: '14 days', ru: '14 дней' },
    ARPPU: { pt: 'ARPPU', en: 'ARPPU', ru: 'ARPPU' },
    Captação: { es: 'Captación', pt: 'Captação', en: 'Acquisition', ru: 'Привлечение' },
    Depositaram: { es: 'Depositaron', pt: 'Depositaram', en: 'Deposited', ru: 'Внесли депозит' },
    Cadastros: { es: 'Registros', pt: 'Cadastros', en: 'Sign-ups', ru: 'Регистрации' },
    'Abriram conta': { es: 'Abrieron cuenta', pt: 'Abriram conta', en: 'Opened account', ru: 'Открыли счёт' },
    // Lentes de salud de red (Resultado / Físico) — terminología ejecutiva.
    // NOTA i18n: varias claves de este panel están en PORTUGUÉS (el componente
    // salud-red-nodo.js las pasa por t() tal cual). Sin campo `es`, t() devolvía la
    // clave literal → el usuario español veía portugués. Se agrega `es` a cada una.
    Resultado: { es: 'Resultado', pt: 'Resultado', en: 'Results', ru: 'Результат' },
    Físico: { es: 'Físico', pt: 'Físico', en: 'Physical', ru: 'Физический' },
    Margem: { es: 'Margen', pt: 'Margem', en: 'Margin', ru: 'Маржа' },
    Hold: { pt: 'Hold', en: 'Hold', ru: 'Hold' },
    Handle: { es: 'Handle', pt: 'Handle', en: 'Handle', ru: 'Оборот' },
    'Receita bruta': { es: 'Renta bruta', pt: 'Receita bruta', en: 'Gross revenue', ru: 'Валовой доход' },
    'GGR − bônus jogado': { es: 'GGR − bono jugado', pt: 'GGR − bônus jogado', en: 'GGR − bonus wagered', ru: 'GGR − сыгранный бонус' },
    'GGR − bônus': { es: 'GGR − bono', pt: 'GGR − bônus', en: 'GGR − bonus', ru: 'GGR − бонус' },
    'Premiado/Apostado': { es: 'Premiado/Apostado', pt: 'Premiado/Apostado', en: 'Paid/Wagered', ru: 'Выплаты/Ставки' },
    'Total apostado': { es: 'Total apostado', pt: 'Total apostado', en: 'Total wagered', ru: 'Всего ставок' },
    Tickets: { es: 'Tickets', pt: 'Bilhetes', en: 'Tickets', ru: 'Билеты' },
    Bilhetes: { es: 'Tickets', pt: 'Bilhetes', en: 'Tickets', ru: 'Билеты' },
    Jugaron: { es: 'Jugaron', pt: 'Jogaram', en: 'Played', ru: 'Играли' },
    Ganaron: { es: 'Ganaron', pt: 'Ganharam', en: 'Won', ru: 'Выиграли' },
    Diferencia: { es: 'Diferencia', pt: 'Diferença', en: 'Difference', ru: 'Разница' },
    Vendidos: { es: 'Vendidos', pt: 'Vendidos', en: 'Sold', ru: 'Продано' },
    Ticket: { es: 'Ticket', pt: 'Bilhete', en: 'Ticket', ru: 'Билет' },
    Médio: { es: 'Medio', pt: 'Médio', en: 'Average', ru: 'Средний' },
    'Ticket médio': { es: 'Ticket medio', pt: 'Ticket médio', en: 'Average ticket', ru: 'Средний билет' },
    '% do total': { es: '% del total', pt: '% do total', en: '% of total', ru: '% от общего' },
    Refrescar: { pt: 'Atualizar', en: 'Refresh', ru: 'Обновить' },
    'Atualizado há': { es: 'Actualizado hace', pt: 'Atualizado há', en: 'Updated', ru: 'Обновлено' },
    'Atualizado agora': { es: 'Actualizado ahora', pt: 'Atualizado agora', en: 'Just updated', ru: 'Только что' },
    'Total da rede': { es: 'Total de la red', pt: 'Total da rede', en: 'Network total', ru: 'Итого по сети' },
    'Vantagem casa': { es: 'Ventaja casa', pt: 'Vantagem casa', en: 'House edge', ru: 'Преимущество' },
    Fresco: { es: 'Fresco', pt: 'Fresco', en: 'Fresh', ru: 'Новые' },
    'Dinheiro novo': { es: 'Dinero nuevo', pt: 'Dinheiro novo', en: 'New money', ru: 'Новые деньги' },
    Rejogo: { es: 'Rejuego', pt: 'Rejogo', en: 'Replay', ru: 'Переигровка' },
    Rejugado: { es: 'Rejugado', pt: 'Rejogo', en: 'Replay', ru: 'Переигровка' },
    'Prêmios reapostados': { es: 'Premios reapostados', pt: 'Prêmios reapostados', en: 'Re-wagered prizes', ru: 'Переставленные' },
    Bônus: { es: 'Bono', pt: 'Bônus', en: 'Bonus', ru: 'Бонус' },
    'Jogado c/ bônus': { es: 'Jugado c/ bono', pt: 'Jogado c/ bônus', en: 'Played w/ bonus', ru: 'Игра с бонусом' },
    'Error al cargar': { pt: 'Erro ao carregar', en: 'Loading error', ru: 'Ошибка загрузки' },
    'Bono jugado': { pt: 'Bônus jogado', en: 'Bonus wagered', ru: 'Сыгранный бонус' },
    'Cuánto se jugó usando saldo de origen bono — no es el monto otorgado': {
        pt: 'Quanto foi jogado usando saldo de origem bônus — não é o valor outorgado',
        en: 'How much was wagered using bonus-origin balance — not the granted amount',
        ru: 'Сколько сыграно с бонусного баланса — не сумма начисления',
    },
    'Jogado c/ bônus': { pt: 'Jogado c/ bônus', en: 'Played w/ bonus', ru: 'Игра с бонусом' },
    'Cuánto se jugó usando saldo de origen bônus en el período': {
        pt: 'Quanto foi jogado usando saldo de origem bônus no período',
        en: 'How much was wagered using bonus-origin balance in the period',
        ru: 'Сколько сыграно с бонусного баланса за период',
    },
    'Jugado con saldo de bônus en el período': {
        pt: 'Jogado com saldo de bônus no período',
        en: 'Wagered with bonus balance in the period',
        ru: 'Сыграно с бонусного баланса за период',
    },
    Nodo: { pt: 'Nó', en: 'Node', ru: 'Узел' },
    'No hay nodos con datos en este período': {
        pt: 'Não há nós com dados neste período',
        en: 'No nodes with data in this period',
        ru: 'Нет узлов с данными за этот период',
    },
    'Desempeño vs media de la red': {
        pt: 'Desempenho vs média da rede',
        en: 'Performance vs network average',
        ru: 'Результат против среднего по сети',
    },
    'Tendencia del GGR': { pt: 'Tendência do GGR', en: 'GGR trend', ru: 'Динамика GGR' },
    'Desvío vs media': { pt: 'Desvio vs média', en: 'Deviation vs average', ru: 'Отклонение от среднего' },
    'Cargando red…': { pt: 'Carregando rede…', en: 'Loading network…', ru: 'Загрузка сети…' },
    'No se pudo cargar la red': {
        pt: 'Não foi possível carregar a rede',
        en: 'Could not load the network',
        ru: 'Не удалось загрузить сеть',
    },
    'Este nodo no tiene sub-nodos para comparar': {
        pt: 'Este nó não tem sub-nós para comparar',
        en: 'This node has no sub-nodes to compare',
        ru: 'У этого узла нет дочерних узлов для сравнения',
    },
    'Selecciona un nodo para ver su red': {
        pt: 'Selecione um nó para ver sua rede',
        en: 'Select a node to see its network',
        ru: 'Выберите узел, чтобы увидеть его сеть',
    },
    'Sin actividad en el período': {
        pt: 'Sem atividade no período',
        en: 'No activity in the period',
        ru: 'Нет активности за период',
    },
    'Sin datos para comparar': {
        pt: 'Sem dados para comparar',
        en: 'No data to compare',
        ru: 'Нет данных для сравнения',
    },
    'Sin tendencia en el período': {
        pt: 'Sem tendência no período',
        en: 'No trend in the period',
        ru: 'Нет динамики за период',
    },
    media: { pt: 'média', en: 'avg', ru: 'средн.' },
    'Amplía el rango (7D, 30D…) para ver la tendencia': {
        pt: 'Amplie o período (7D, 30D…) para ver a tendência',
        en: 'Widen the range (7D, 30D…) to see the trend',
        ru: 'Расширьте диапазон (7D, 30D…), чтобы увидеть динамику',
    },
};
